import { render } from "./UserLocations.vue?vue&type=template&id=084e6f74"
import script from "./UserLocations.vue?vue&type=script&lang=js"
export * from "./UserLocations.vue?vue&type=script&lang=js"

import "./UserLocations.vue?vue&type=style&index=0&id=084e6f74&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__